import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { ActionIcon, Button, Checkbox, Menu, Stack, Text } from '@mantine/core'
import { randomArrayItem } from '@utils/randomArrayItem'
import { IconDots } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { useAppDispatch } from '@hooks/redux'
import { setActiveSection } from '@redux/site/siteSlice'

const MOCK_DATA = Array(30)
  .fill(0)
  .map((_, i) => {
    return {
      id: `location-fields-${i}`,
      fieldLabel: 'Custom field label',
      dataType: randomArrayItem([
        'Unique ID',
        'Text',
        'Date',
        'Email',
        'Picklist',
        'Number',
      ]),
      createdBy: 'Alfredo Carrillo',
      createdOn: (
        <Stack gap={0}>
          <Text size="xs">5:59pm</Text>
          <Text size="xs" c="dimmed">
            Mar 11
          </Text>
        </Stack>
      ),
      lastUpdateBy: 'Joey Cadle',
      lastUpdateOn: (
        <Stack gap={0}>
          <Text size="xs">5:59pm</Text>
          <Text size="xs" c="dimmed">
            Mar 11
          </Text>
        </Stack>
      ),
    }
  })

export const CustomFields = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [hiddenRows, setHiddenRows] = useState<string[]>([])

  useEffect(() => {
    dispatch(setActiveSection('Custom Fields'))
  })

  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })

  const handleToggleHide = (item: any) => {
    if (hiddenRows.includes(item.id)) {
      const newRows = hiddenRows.filter((row) => row !== item.id)
      setHiddenRows(newRows)
    } else {
      setHiddenRows([...hiddenRows, item.id])
    }
  }

  const data = MOCK_DATA.map((d, i) => ({
    ...d,
    hidden: (
      <Checkbox checked={hiddenRows.includes(`custom-fields-${i}`)} disabled />
    ),
  }))

  const columns: DataGridColumns[] = [
    {
      label: 'Field Label',
      prop: 'fieldLabel',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Data type',
      prop: 'dataType',
    },
    {
      label: 'Hidden',
      prop: 'hidden',
    },
    {
      label: 'Created by',
      prop: 'createdBy',
    },
    {
      label: 'Created on',
      prop: 'createdOn',
    },
    {
      label: 'Last update by',
      prop: 'lastUpdateBy',
    },
    {
      label: 'Last update on',
      prop: 'lastUpdateOn',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Custom Fields',
      href: '#',
      default: true,
    },
    {
      label: 'Contact Fields',
      href: '#',
    },
    {
      label: 'Child Fields',
      href: '#',
    },
    {
      label: 'Staff Fields',
      href: '#',
    },
    {
      label: 'Partner Fields',
      href: '#',
    },
    {
      label: 'Place Fields',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Toggle Hidden',
      onClick: (item: any) => handleToggleHide(item),
    },
    {
      label: 'Delete',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Hide all',
      onClick: (items: any) => console.log('Selected Actions: Edit'),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item color="red">Delete</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  const handleButtonClick = () =>
    navigate(
      [
        RoutePaths.ADMIN_SETTINGS,
        RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL,
        RoutePaths.ADMIN_SETTINGS_CUSTOM_FIELDS_CONTROL_DATA_TYPE,
      ].join('/'),
    )

  return (
    <DataGrid
      data={data}
      columns={columns}
      sections={sections}
      actions={actions}
      results={data.length}
      buttons={<Button onClick={handleButtonClick}>Add Field</Button>}
      selectedActions={selectedActions}
      page={1}
    />
  )
}
